<template>
  <div>
    <toast-notification ref="toast" />
  </div>
</template>

<script>
import * as messageService from '@/common/message-service';
import ToastNotification from "@/components/module/shared/ToastNotification";

export default {
  name: "GlobalMessage",
  components: { ToastNotification },
  props: ['globalErrors', 'message', 'warning'],
  computed: {
    showGlobalMsg() {
      return this.globalErrors != null && this.globalErrors.length !== 0;
    },
    showMessage() {
      return !!this.message;
    },
    showWarning() {
      return !!this.warning;
    }
  },
  methods: {
    getMsg(messageObj) {
      if (typeof messageObj === 'string') {
        return messageObj.replace(/\./g, ' ').toLowerCase();
      }

      let msg = messageService.getMessage(messageObj.code);
      if (!msg) {
        msg = messageService.getMessage(messageObj.defaultMessage);
      }
      if (messageObj.arguments && messageObj.arguments.length !== 0) {
        msg = messageService.replaceMsgWithArgs(msg, messageObj.arguments);
      }
      return msg;
    },
    resetMsg() {
      this.$emit("clearMessages");
    },
    cleanUpMessage(newValue) {
      if (newValue) {
        setTimeout(() => {
          this.resetMsg();
        }, 1000);
      }
    },
  },
  watch: {
    showGlobalMsg(newValue) {
      if (newValue && this.globalErrors) {
        this.globalErrors.forEach(err => {
          this.$refs.toast.show(this.getMsg(err), 'error', 4000);
        });
      }
      this.cleanUpMessage(newValue);
    },
    showMessage(newValue) {
      if (newValue && this.message) {
        this.$refs.toast.show(this.message, 'success', 3000);
      }
      this.cleanUpMessage(newValue);
    },
    showWarning(newValue) {
      if (newValue && this.warning) {
        this.$refs.toast.show(this.getMsg(this.warning), 'warning', 3500);
      }
      this.cleanUpMessage(newValue);
    }
  }
};
</script>
<style scoped>
.success-text{
  color: #55EFC4 !important;
}
.alert-text{
  color: #9d7800 !important;
}

</style>
